// A tiny synth for cues. No samples to download; everything is a few oscillators.

export type SoundName = 'ding' | 'buzz' | 'pop' | 'chime' | 'tick';

let ac: AudioContext | null = null;
let enabled = true;

export function setSoundEnabled(on: boolean) { enabled = on; }

function ctx(): AudioContext | null {
  if (!enabled) return null;
  try {
    if (!ac) ac = new (window.AudioContext || (window as any).webkitAudioContext)();
    if (ac.state === 'suspended') ac.resume();
    return ac;
  } catch { return null; }
}

function tone(freq: number, dur: number, type: OscillatorType, gain = 0.15, when = 0, slide?: number) {
  const a = ctx(); if (!a) return;
  const o = a.createOscillator();
  const g = a.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, a.currentTime + when);
  if (slide) o.frequency.exponentialRampToValueAtTime(slide, a.currentTime + when + dur);
  g.gain.setValueAtTime(0.0001, a.currentTime + when);
  g.gain.exponentialRampToValueAtTime(gain, a.currentTime + when + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, a.currentTime + when + dur);
  o.connect(g).connect(a.destination);
  o.start(a.currentTime + when);
  o.stop(a.currentTime + when + dur + 0.02);
}

export function play(name: SoundName) {
  switch (name) {
    case 'ding': tone(880, 0.12, 'sine', 0.18); tone(1320, 0.18, 'sine', 0.12, 0.08); break;
    case 'chime': tone(660, 0.15, 'sine', 0.15); tone(880, 0.15, 'sine', 0.15, 0.12); tone(1320, 0.3, 'sine', 0.15, 0.24); break;
    case 'buzz': tone(160, 0.18, 'square', 0.06, 0, 110); break;
    case 'pop': tone(520, 0.06, 'triangle', 0.15, 0, 260); break;
    case 'tick': tone(1200, 0.03, 'square', 0.04); break;
  }
}
